export default "__VITE_ASSET__hq6CHetB__"